// extracted by mini-css-extract-plugin
export default {"canvas":"canvas__U9WA1","portrait":"portrait__t-4s5","landscape":"landscape__M5ek6"};